import { lists } from "./src/Lists";

(function (Drupal) { // closure
    'use strict';
    Drupal.behaviors.lists = lists;
}(Drupal));
